// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_JOURNEY_PARAMS = 'uiState/layout/booking/SET_JOURNEY_PARAMS';
export const SET_BOOKING_IN_PROCESS =
  'uiState/layout/booking/SET_BOOKING_IN_PROCESS';

export function setJourneyParams(journeyId: number, token: string): PureAction {
  return {
    type: PURE(SET_JOURNEY_PARAMS),
    journeyId,
    token,
  };
}

export function setBookingInProcess(bookingInProcess: boolean): PureAction {
  return {
    type: PURE(SET_BOOKING_IN_PROCESS),
    bookingInProcess,
  };
}
